import { useQuery as s } from "react-query";
import { getAdapter as r } from "../../adapter.js";
import { useEnvironment as c } from "../../../common/hooks/environment/useEnvironment.js";
import { useAuth as d } from "../../../auth/hooks/useAuth.js";
import { StampAccountAdapter as p } from "../../models/loyalty/stampAccount/stampAccount.adapter.js";
import { ScopeAdapter as i } from "../../models/scope/scope.adapter.js";
function j() {
  const {
    backendBaseUrl: t
  } = c(), {
    token: o,
    customer: n,
    scope: e
  } = d();
  return s(
    ["stamp-account", o, n],
    async () => {
      const m = r(i), u = await (await fetch(`${t}/user/stampcard/?${m.toQueryString(e)}`, {
        method: "GET",
        headers: {
          authorization: `Token ${o}`
        }
      })).json(), a = r(p);
      return (u.records ?? []).map(a.adapt.bind(a));
    },
    {
      refetchOnWindowFocus: !1
    }
  );
}
function b(t) {
  const {
    backendBaseUrl: o
  } = c();
  return s(
    ["stamp-account", t],
    async () => {
      const e = await (await fetch(`${o}/stamp-card/item/${t}/`, {
        method: "GET"
      })).json();
      return r(p).adapt(e);
    }
  );
}
export {
  j as useStampCardAccount,
  b as useStampCardAccountFromKey
};
//# sourceMappingURL=useStampCardAccount.js.map
